module.exports = "/assets/30770e323028cddacf585d2ac97b96c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MW.png
// module id = 1629
// module chunks = 0